import React from 'react'
import ApartmentShowcase from '../component/ApartmentsOverviewWithImages'
import ContactSection from '../component/ContactSection'
import ApartmentHeroGeneral from '../component/ApartmentHero'
import TestimonialsSection from '../component/TestimonialsSection'
import VideoSection from '../component/VideoSection'
import LocationSection from '../component/LocationSection'
import FAQsSectionApartment from '../component/FaqSectionApartment'

const Apartments = () => {
  return (
   <>
   <ApartmentHeroGeneral/>
   <ApartmentShowcase />
   <VideoSection />
   <TestimonialsSection />
   <FAQsSectionApartment/>
   <LocationSection />
   <ContactSection />
   </>
  )
}

export default Apartments
